// extracted by mini-css-extract-plugin
export var active = "Hamburger-module--active--2a8ff";
export var core = "Hamburger-module--core--9d772";
export var hover = "Hamburger-module--hover--c0e9d";
export var open = "Hamburger-module--open--13515";
export var switchLanguage = "Hamburger-module--switchLanguage--d600b";